import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
const StatusAlert = ({ errors, className }) => {
    const { t } = useTranslation();
    const text = useMemo(() => {
        if (errors.has('encounter_cancelled')) {
            return t('text.notes.status_alert.encounter_cancelled');
        }
        if (errors.has('encounter_not_started')) {
            return t('text.notes.status_alert.encounter_not_started');
        }
        if (errors.has('is_locked_without_addendum')) {
            return t('text.notes.status_alert.is_locked_without_addendum');
        }
        if (errors.has('is_locked_with_addendum')) {
            return t('text.notes.status_alert.is_locked_with_addendum');
        }
    }, [errors]);
    if (!text) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", Object.assign({ className: classNames('alert alert--warning', className) }, { children: text })));
};
export default memo(StatusAlert);
